define('presentation/analytics/validators/addScheduledReportModalViewModelValidator',[
        'common/promises/promiseFactory',
        'common/specifications/validEmailAddressSpecification',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule',
    ],
    function() {
        return function() {
            let self = this;

            let _facade = null;
            let _viewModel = null;
            let _commonValidator = null;

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const ValidEmailAddressSpecificationConstructor = require('common/specifications/validEmailAddressSpecification');
            const _validEmailAddressSpecification = new ValidEmailAddressSpecificationConstructor();

            self.registerViewModel = (viewModel, facade) => {

                _viewModel = viewModel;
                _facade = facade;
                _commonValidator = new CommonValidatorConstructor(_viewModel);

                const validationRules = new ValidationRulesConstructor();
                validationRules.field("subject")
                    .addValidationI18n(_commonValidator.isStringWithValue, 'addScheduledReportModal:subjectRequired');
                validationRules.array("sendToEmailAddresses")
                    .arrayField("emailAddress")
                    .addValidationKeyUp(_validateEmailAddress)
                    .addValidationI18n(_validateEmailAddress, 'emailAddressInvalid')
                    .addValidationI18n(_isEmailAddressUnique, 'emailAddressDuplicate');

                _commonValidator.setValidationRules(validationRules);
            };

            self.validate = () => {
                return _commonValidator.validate();
            };

            self.validateMinimumRequiredFields = () => {
                return _promiseFactory.defer((deferredObject) => {
                    const hasAtLeastOneRequiredField = !_areRequiredInputsEmpty();
                    deferredObject.resolve(hasAtLeastOneRequiredField);
                });
            };

            const _isArrayOfInputsEmpty = (inputs) => {
                return !inputs.some((input) => _commonValidator.isStringWithValue(input));
            };

            const _areRequiredInputsEmpty = () => {
                const emailAddresses = _viewModel.sendToEmailAddresses().map((recipient) => recipient.emailAddress());
                return _isArrayOfInputsEmpty(emailAddresses);
            };

            const _validateEmailAddress = (emailAddress) => {
                if (_commonValidator.isStringWithValue(emailAddress)) {
                    return _validEmailAddressSpecification.isSatisfiedBy(emailAddress.trim());
                } else {
                    return true;
                }
            };

            const _isEmailAddressUnique = (emailAddress) => {
                const reportRecipients = _viewModel.sendToEmailAddresses();
                const matchingEmailAddresses = reportRecipients.filter((e) => {
                    return e.emailAddress().trim().toLowerCase() === emailAddress.trim().toLowerCase();
                });
                return matchingEmailAddresses.length === 1;
            };
        };
    });
